import { render, staticRenderFns } from "./ShareUiForHD.vue?vue&type=template&id=c3b87228&scoped=true"
import script from "./ShareUiForHD.vue?vue&type=script&lang=js"
export * from "./ShareUiForHD.vue?vue&type=script&lang=js"
import style0 from "./ShareUiForHD.vue?vue&type=style&index=0&id=c3b87228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b87228",
  null
  
)

export default component.exports